import {AnyAction} from 'redux';
import Types from '../../../actions/Types';

import UserNotification from '../../../../domain/entities/writer/UserNotification';

export default function reducer(
  state: {[key: number]: UserNotification} = {},
  action: AnyAction,
): {[key: number]: UserNotification} {
  switch (action.type) {
    case Types.IndexWriterUserNotificationsSuccess:
      return {
        ...state,
        ...action.payload.records.reduceRight(
          (
            obj: {[key: number]: UserNotification},
            record: UserNotification,
          ) => {
            obj[record.id] = record;
            return obj;
          },
          {},
        ),
      };
    case Types.UpdateWriterUserNotificationSuccess:
      return {
        ...state,
        [action.payload.id]: action.payload,
      };
    default:
      return state;
  }
}
